<template>
  <div class="flex flex-wrap content-start">
    <pre v-if="debug">
      {{ department_topics }}
    </pre>
    <div v-for="subject in subjects"
       @click="handle_subject_link(subject.id)"
       :key="subject.id"
       class="relative cursor-pointer w-5/12 h-32 mr-4 mb-4 bg-ams-blue flex flex-col items-end">
      <score-bar :id="subject.id" type="subject"></score-bar>
      <span class="absolute break-words bottom-0 text-white py-3 px-2 text-right text-xl" v-html="subject.title"></span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import ScoreBar from './score_bar.vue'

export default {
  data() {
    return {
      debug: false
    }
  },
  methods: {
    ...mapMutations(['set_current_subject_id', 'set_current_topic_id']),
    handle_subject_link( id ) {
      this.set_current_subject_id( id )
      this.$router.push(`/subject/${id}`)
    }
  },
  computed: {
    ...mapGetters(['topic_subjects']),
    subjects() {
      return this.topic_subjects(this.$route.params.id)
    }
  },
  components: {
    ScoreBar
  }
}
</script>